import { redirect } from "react-router";
import Axios from "axios"


export async function auth({unstable_pattern}) {
    let check
    if(unstable_pattern === '/omega') {
        check = 'omega'
    }
    else if(unstable_pattern === '/cmath') {
        check = 'cmath'
    }

    if(check) {
        const result = await Axios
                        .post("/auth", {
                            check: check
                        })
        const data = result['data']
        console.log(data)
        if(data['status'] === 'fail') {
            alert('잘못된 접근입니다.')
            throw redirect('/')
        }

        return data['data']
    }
    else {
        alert('잘못된 접근입니다.')
        throw redirect('/')
    }
}